<template>
  <div :class="containerClass" class="mb-5">
    <div :style="{ overflowY: isMobSmallScreen ? 'scroll' : '', marginBottom: isMobSmallScreen ? '25px' : '' }">
      <header>
        <button class="back-button" @click="goBack">
          <span class="back-icon"><span class="material-icons icon-32pt">navigate_before</span></span>
          <h2 style="margin-bottom: 0px;">SkillCards Sets</h2>
        </button>
        <div class="card-counter">Card {{ cards.length === 0 ? 0 : currentIndex + 1 }} of {{ cards.length }}</div>
      </header>

      <div class="progress-bar-container">
        <div
          class="progress-bar"
          :style="{ width: progressWidth + '%', backgroundColor: get(getLoggedInUser, 'linked_entity.primary_color') }"
        ></div>
      </div>

      <div
        class="card-container"
        :style="{ width: isMobSmallScreen ? '100%' : '60%', height: isMobSmallScreen ? '35rem' : '500px' }"
        v-if="isLoading"
      >
        <div class="card no-flashcards-container">
          <p class="text-70" style="font-size: larger;">
            <i class="fas fa-circle-notch fa-spin"></i>
          </p>
        </div>
      </div>
      <div
        class="card-container"
        :style="{ width: isMobSmallScreen ? '100%' : '60%', height: isMobSmallScreen ? '35rem' : '500px' }"
        v-else-if="cards.length === 0 && !isLoading"
      >
        <div class="card no-flashcards-container">
          <p class="text-70 ">No flashcards to display</p>
        </div>
      </div>

      <div
        v-else
        class="card-container"
        :style="{ width: isMobSmallScreen ? '100%' : '60%', height: isMobSmallScreen ? '35rem' : '500px' }"
      >
        <div v-if="!isImageLoaded" class="card no-flashcards-container">
          <img :src="currentCard.image" @load="onImageLoad" style="display: none;" />
          <p class="text-70" style="font-size: larger;">
            <i class="fas fa-circle-notch fa-spin"></i>
          </p>
        </div>
        <div v-else class="card" :class="{ flipped: flipped }" @click="flipCard">
          <div class="card-face card-front">
            <img
              :src="currentCard.image"
              alt="skill demonstration"
              style="border-radius: 0.5rem; object-fit:cover; height: 35rem; width: 100%;"
            />
            <div class="card-counter-badge">{{ currentIndex + 1 }}/{{ cards.length }}</div>
            <div class="card-actions">
              <b-btn class="flip-icon" :style="{ bottom: isMobSmallScreen ? '12px' : '40px' }"
                ><md-icon class="mr-2">repeat</md-icon>Click to flip</b-btn
              >
            </div>
          </div>
          <div class="card-face card-back">
            <div
              class="card-back-header"
              :style="{ backgroundColor: get(getLoggedInUser, 'linked_entity.primary_color') }"
            >
              <p style="color: white;">{{ currentCard.skillmap }}</p>
              <div class="card-counter-badge">{{ currentIndex + 1 }}/{{ cards.length }}</div>
            </div>
            <div v-if="currentCard.step" class="card-back-content">
              <div
                class="card-back-text scrollable-content"
                :style="{ maxHeight: isMobSmallScreen ? '170px' : '310px' }"
              >
                {{ currentCard.step }}
              </div>
            </div>
            <div class="card-actions card-back-actions">
              <b-btn class="flip-icon" :style="{ bottom: isMobSmallScreen ? '12px' : '40px' }"
                ><md-icon class="mr-2">repeat</md-icon>Click to flip</b-btn
              >
            </div>
          </div>
        </div>
      </div>

      <div v-if="cards.length > 0 && !isLoading" class="navigation-buttons">
        <button class="nav-button prev-button" @click="prevCard" :disabled="currentIndex === 0">
          <span class="nav-icon"><md-icon>chevron_left</md-icon></span>
          Previous
        </button>
        <button
          class="nav-button next-button"
          :style="{ marginLeft: isMobSmallScreen ? '5px' : '8px' }"
          @click="nextCard"
          :disabled="currentIndex === cards.length - 1"
        >
          Next
          <span class="nav-icon"><md-icon>chevron_right</md-icon></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue';
import { mapActions, mapGetters } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'FlashCards',
  extends: Page,
  data() {
    return {
      currentIndex: 0,
      flipped: false,
      cards: [],
      isLoading: true,
      currentCard: {},
      progressWidth: 0,
      isImageLoaded: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
    isMobSmallScreen() {
      return this.windowWidth <= 420;
    },
  },
  methods: {
    get,
    ...mapActions('aiSkills', ['getSkillsetCards']),
    flipCard() {
      this.flipped = !this.flipped;
    },
    nextCard() {
      if (this.currentIndex < this.cards.length - 1) {
        this.currentIndex++;
        this.flipped = false;
        this.isImageLoaded = false;
        this.currentCard = this.cards[this.currentIndex];
        this.progressWidth = ((this.currentIndex + 1) / this.cards.length) * 100;
      }
    },
    onImageLoad() {
      this.isImageLoaded = true;
    },
    prevCard() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.flipped = false;
        this.isImageLoaded = false;
        this.progressWidth = ((this.currentIndex + 1) / this.cards.length) * 100;
        this.currentCard = this.cards[this.currentIndex];
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    async fetchSkillsetCards() {
      this.isLoading = true;
      const skillmap = this.$route.query.skillmap;
      if (skillmap) {
        const resp = await this.getSkillsetCards({ skillmap: skillmap });
        this.cards = resp.data || [];
        this.progressWidth = ((this.currentIndex + 1) / this.cards.length) * 100;
        this.currentCard = this.cards[this.currentIndex];
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.cards = [];
      }
    },
  },
  mounted() {
    this.fetchSkillsetCards();
  },
};
</script>

<style scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.back-button {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.back-icon {
  margin-right: 8px;
}

.card-counter {
  font-size: 14px;
  color: #666;
}

.progress-bar-container {
  height: 8px;
  background-color: #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 30px;
}

.progress-bar {
  height: 100%;
  transition: width 0.3s ease;
}

.card-container {
  perspective: 1000px;
  justify-self: center;
  margin-bottom: 30px;
}

.card {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: transform 0.8s;
  cursor: pointer;
}

.card.flipped {
  transform: rotateY(180deg);
}

.card-face {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.card-front {
  background-color: white;
  display: flex;
  flex-direction: column;
}

.card-back {
  background-color: white;
  transform: rotateY(180deg);
  display: flex;
  flex-direction: column;
}

.card-counter-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: rgb(0, 0, 0, 0.5);
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: white;
}

.card-actions {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

.card-back-header {
  color: white;
  padding: 20px;
  position: relative;
}

.card-back-header p {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: white;
  text-transform: uppercase;
}

.card-back-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
}
.scrollable-content {
  background-color: #f1f1f1;
  border-radius: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  padding: 15px;

  overflow-y: auto;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  overscroll-behavior: contain;
  scroll-behavior: smooth;
}
.card-back-text {
  background-color: #f1f8ff;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  font-size: 18px;
  line-height: 1.5;
  color: #2c3e50;
}

.no-flashcards-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: medium;
  font-style: italic;
}

.flip-icon {
  position: absolute;
  align-self: flex-end;
  justify-self: anchor-center;
  padding: 10px;
  cursor: pointer;
  text-transform: none;
  border: none;
  color: white;
  background-color: rgb(0, 0, 0, 0.5);
  transition: background-color 0.3s;
}

.flip-icon:hover {
  opacity: 1;
  background-color: black;
}

.card-back-actions {
  justify-content: center;
}

.navigation-buttons {
  display: flex;
  justify-content: center;
}

.nav-button {
  padding: 12px 20px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  transition: all 0.2s;
}

.nav-button:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.nav-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nav-icon {
  margin: 0 8px;
}

.prev-button .nav-icon {
  margin-right: 8px;
  margin-left: 0;
}

.next-button .nav-icon {
  margin-left: 8px;
  margin-right: 0;
}

@media (max-width: 600px) {
  .card-container {
    height: 270px;
  }

  .card-back-header p {
    font-size: 18px;
  }

  .card-back-text {
    font-size: 16px;
    padding: 15px;
  }
  .back-button h2 {
    font-size: 20px;
  }
}
</style>
